export default "__VITE_ASSET__D9_7izus__"